import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { setLenis, getLenis, scrollToId } from "@/lib/lenis";
import { Preloader } from "@/components/site/Preloader";
import { Cursor } from "@/components/site/Cursor";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Explorer } from "@/components/site/Explorer";
import { Transformations } from "@/components/site/Transformations";
import { Process } from "@/components/site/Process";
import { Owner } from "@/components/site/Owner";
import { Proof } from "@/components/site/Proof";
import { Region } from "@/components/site/Region";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";
import { Materials } from "@/components/site/Materials";
import { Statement } from "@/components/site/Statement";
import { ScrollFrame } from "@/components/site/Motion";
import About from "@/pages/About";

const Home = ({ ready }) => (
  <main>
    <Hero ready={ready} />
    <Marquee />
    <Transformations />
    <Statement />
    <ScrollFrame><Services /></ScrollFrame>
    <Materials />
    <Explorer />
    <Owner />
    <ScrollFrame><Process /></ScrollFrame>
    <Proof />
    <Region />
    <Contact />
  </main>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollToId(hash.slice(1)), 350);
    else getLenis()?.scrollTo(0, { immediate: true });
  }, [pathname, hash]);
  return null;
};

function App() {
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  const onReveal = useCallback(() => setReady(true), []);
  const onDone = useCallback(() => setLoading(false), []);

  return (
    <div className="App relative bg-[#0A0A0A]">
      <BrowserRouter>
        <ScrollManager />
        {loading && <Preloader onReveal={onReveal} onDone={onDone} />}
        <Cursor />
        <div className="grain" />
        <Nav ready={ready} />
        <Routes>
          <Route path="/" element={<Home ready={ready} />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <Toaster theme="dark" position="bottom-left" />
      </BrowserRouter>
    </div>
  );
}

export default App;
